import { rawDataToScheduleDepositionListItem } from 'src/dataFactory/scheduleDepositionFactory';

export function handleGetScheduleDepositionsSuccess(action, response) {
  const convertedData = rawDataToScheduleDepositionListItem(response.scheduleDepositions);
  action.onSuccess(convertedData, response.total);
}
